export type IMesOrderStatus = {
    id: number,
    code: MesOrderStatusCode,
    name: string,
}

export enum MesOrderStatusCode {
    New = 'new',
    Reserved = 'reserved',
    Work = 'work',
    Completed = 'completed',
    CompletedPartial = 'completed-partial',
    Blocked = 'blocked',
    Cancelled = 'cancelled',
    Deleted = 'deleted',
}

export const MesOrderStatusSpec: { [key in MesOrderStatusCode]: Omit<IMesOrderStatus, 'code'> } = {
    [MesOrderStatusCode.Reserved]: { id: -3, name: 'Без технологии' },
    [MesOrderStatusCode.New]: { id: -1, name: 'Новый' },
    [MesOrderStatusCode.Work]: { id: 0, name: 'В работе' },
    [MesOrderStatusCode.Completed]: { id: 1, name: 'Завершен' },
    [MesOrderStatusCode.CompletedPartial]: { id: 2, name: 'Завершен частично' },
    [MesOrderStatusCode.Blocked]: { id: 90, name: 'Заблокирован' },
    [MesOrderStatusCode.Cancelled]: { id: 80, name: 'Отменен' },
    [MesOrderStatusCode.Deleted]: { id: 1000, name: 'Удален' },
}


export const MesOrderStatusList: IMesOrderStatus[] = Object.keys(MesOrderStatusSpec).map(code => ({
    ...MesOrderStatusSpec[code as keyof typeof MesOrderStatusSpec],
    code: code as MesOrderStatusCode,
}));
